import { render, staticRenderFns } from "./td.vue?vue&type=template&id=5e247ef9&"
import script from "./td.vue?vue&type=script&lang=ts&"
export * from "./td.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports